// controllers/modelo_fluxo_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "drawflowInput", "fasesInput"]

  connect() {
    // Optional: log for debugging
    console.log("ModeloFluxoFormController connected")
  }

  async handleSubmit(event) {
    event.preventDefault() // 🛑 prevent immediate submission

    try {
      // get latest data
      const drawflowData = window?.drawflowEditor?.export() || {}
      const fasesData = window._stagedFlow || {}

      // populate hidden fields
      this.drawflowInputTarget.value = JSON.stringify(drawflowData)
      this.fasesInputTarget.value = JSON.stringify(fasesData)

      // ✅ now submit the form normally
      this.formTarget.submit()
    } catch (error) {
      console.error("Error serializing flow:", error)
      alert("Erro ao preparar dados do fluxo antes de salvar.")
    }
  }
}
